import React from 'react'
import SubmitButton from '../../Form/SubmitButton/index'

export const ButtonWithTextUnstyled = props => (
  <SubmitButton
    className={props.className}
    onClick={props.onClickHandler}
    value={props.title}
  >
    <label>{props.label || 'Add user'}</label>
  </SubmitButton>
)



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonWithText/unstyled.js